<template lang="pug">
div
  app-divider.container-input(label="Custas processuais", :showBorder="true")
  .custas
    el-checkbox-group(v-model="custasVtn" @change="handleChange")
      el-checkbox(
        v-for='custa in tiposCustas'
        v-if="custa.grupo === 'PROCESSUAIS'"
        :checked="selecionado(custa.id)"
        :label='custa'
        :disabled="marcadoPadrao(custa.codigo)"
        :key='custa.id'
      ).checkbox
        .label {{custa.descricao}}

</template>
<script>
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppDivider
  },

  data () {
    return {
      checkedCustas: []
    }
  },

  computed: {
    custasVtn () {
      return this.$store.state.vtn.dadosVtn.custasVtn
    },

    tiposCustas () {
      return this.$store.state.vtn.tiposCustas
    }
  },

  methods: {
    handleChange (value) {
      const custa = value.target._value
      this.$store.commit('vtn/SET_CUSTA', { tipoCusta: { ...custa } })
    },

    selecionado (id) {
      return !!this.$store.state.vtn.dadosVtn.custasVtn.find(custa => custa.tipoCusta.id === id)
    },

    marcadoPadrao (tipo) {
      return tipo === 'PRI' || tipo === 'EEPA'
    }
  }
}
</script>

<style lang="scss" scoped>
.custas {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
}

.label {
  font-size: 16px;
  font-weight: normal;
}

.checkbox {
  white-space: normal;
  display: block;
  margin: 5px;
}

@media screen and (max-width: 1200px) {
  .input-custas{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustasVtn.vue